import { CookieConsentState } from '@/types/cookie-consent';
import {
  defaultConsent,
  updateGTMConsent,
  initializeTracking,
} from '@/utils/gtm';
import { useState, useEffect } from 'react';

export const useConsentManagement = () => {
  const [consentState, setConsentState] = useState<CookieConsentState>(() => {
    const stored = localStorage.getItem('cookieConsent');
    return stored
      ? JSON.parse(stored)
      : { hasConsent: false, settings: defaultConsent };
  });

  useEffect(() => {
    localStorage.setItem('cookieConsent', JSON.stringify(consentState));

    if (consentState.hasConsent) {
      // Only initialize tracking if consent is given
      //   if (consentState.settings.analytics_storage === 'granted') {
      //     initializeTracking();
      //   }
      initializeTracking();
      // Update GTM consent settings
      updateGTMConsent(consentState.settings);
    }
  }, [consentState]);

  return { consentState, setConsentState };
};
